import { FormCondition, SpecialConditionData } from '@urbanx/agx.campaigns.client';
import { AgxBuildingAndPest } from '@urbanx/agx.ui-components2';
import { useEffect } from 'react';
import { BUILDING_AND_PEST_STEP_NAME, isBuildingAndPestComplete } from './ContractComplianceHelper';
import { ContractCompliancePageProps } from './ContractCompliancePageProps';

const EMPTY_SPECIAL_CONDITIONS: SpecialConditionData[] = [];

interface ContractComplianceBuildingAndPestProps extends ContractCompliancePageProps {
  buildingAndPestCondition?: FormCondition;
  specialConditions?: SpecialConditionData[];
  onBuildingAndPestValidationErrorChange?: (hasValidationError: boolean) => void;
  onBuildingAndPestConditionUpdated?: (buildingAndPestCondition: FormCondition | undefined) => void;
}

const ContractComplianceBuildingAndPest = ({
  buildingAndPestCondition,
  campaign,
  onBuildingAndPestValidationErrorChange,
  onBuildingAndPestConditionUpdated,
  specialConditions,
  task,
  toggleTaskStep,
}: ContractComplianceBuildingAndPestProps) => {
  const BUILDING_AND_PEST_LABEL = 'Building & Pest';
  const step = task.taskSteps?.find((taskStep) => taskStep.name === BUILDING_AND_PEST_STEP_NAME);
  const resolvedSpecialConditions = specialConditions ?? EMPTY_SPECIAL_CONDITIONS;

  const isValid = isBuildingAndPestComplete(buildingAndPestCondition);

  useEffect(() => {
    if (!step?.order) return;

    if ((step.isCompleted ?? false) !== isValid) {
      toggleTaskStep(step.order, isValid);
    }
  }, [isValid, step?.isCompleted, step?.order, toggleTaskStep]);

  return (
    <AgxBuildingAndPest
      id="contract-compliance-building-and-pest"
      label={BUILDING_AND_PEST_LABEL}
      defaultValue={buildingAndPestCondition}
      validate
      campaignId={campaign.campaignId ?? ''}
      specialConditions={resolvedSpecialConditions}
      defaultToNotApplicable
      onIsValidChange={(isValid) => {
        onBuildingAndPestValidationErrorChange?.(
          Boolean(buildingAndPestCondition?.condition) && !isValid
        );
      }}
      onValueChanged={({ value }) => {
        onBuildingAndPestConditionUpdated?.(value);
      }}
    />
  );
};

export default ContractComplianceBuildingAndPest;
